import { createFileRoute } from '@tanstack/react-router';
import { JourneysPeopleMergeHandoff } from '@/pages/workspaces/people/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';
import { validateMergeSearch } from './-people-merge-search';

/**
 * The legacy `/journeys/people/merge` URL — what the embedded app's person
 * page and activity log still link to. Flag off it renders the embedded Ember
 * host; flag on it forwards to the migrated URL, query string included.
 *
 * `appBundle` belongs here and not on the migrated twin: this URL keeps the
 * `journeys` segment, so the resolver's bundle-aware branch can rebuild the
 * target from the bundle prefix when the `/workspaces/last` sentinel needs
 * resolving.
 */
function JourneysPeopleMergeRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysPeopleMergeHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/people/merge')({
  component: JourneysPeopleMergeRoute,
  validateSearch: validateMergeSearch,
});
